import { Timestamp } from "firebase/firestore";

export function castDateToFireStoreDate(feature) {
  for (const key in feature) {
    if (feature[key] instanceof Date) {
      feature[key] = Timestamp.fromDate(feature[key]);
    }
  }
  return feature;
}
